import * as React from 'react';

import type { CmlContent } from '__generated__/graphql-types-do-not-use';

import { Grid, Typography } from '@coursera/cds-core';

import TrackedDiv from 'bundles/page/components/TrackedDiv';
import LearningObjective from 'bundles/unified-description-page-common/components/shared/LearningObjective';
import Subsection from 'bundles/unified-description-page-common/components/shared/Subsection';
import { useMWebStreamlinedXDP } from 'bundles/unified-description-page-common/utils/useStreamlinedXDP';

import _t from 'i18n!nls/xdp';

type Props = {
  learningObjectives?: CmlContent[];
  title?: string;
};

const LearningObjectives = ({ learningObjectives, title }: Props) => {
  const isMWebStreamlinedXDP = useMWebStreamlinedXDP();

  if (!learningObjectives?.length) {
    return null;
  }

  return (
    <Subsection
      title={<Typography variant="h2semibold">{title ?? _t("What you'll learn")}</Typography>}
      spacing={isMWebStreamlinedXDP ? 12 : 24}
    >
      <TrackedDiv
        trackingName="what_you_will_learn_section"
        withVisibilityTracking={true}
        requireFullyVisible={false}
        trackClicks={false}
      >
        <Grid container spacing={16} component="ul">
          {learningObjectives.map((objective, index) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <Grid item xs={12} sm={6} key={index} component="li">
                <LearningObjective objective={objective} />
              </Grid>
            );
          })}
        </Grid>
      </TrackedDiv>
    </Subsection>
  );
};

export default LearningObjectives;
